import React, { ComponentType, ReactNode } from 'react'
import { LimitedWidthContainer } from 'src/layout/page/LimitedWidthContainer'
import { View } from 'src/ui/basic/View'
import { Theme } from 'src/ui/style/Theme'
import { css } from 'src/ui/style/css'
import {
    horizontalPaddedContent,
    paddedContent
} from 'src/ui/style/mixins/layout'

export type Section = {
    children: ReactNode
    top?: () => ReactNode
    className?: string
    containerMaxWidth?: string
}

export const CardSection: ComponentType<Section> = ({
    children,
    top,
    className,
    containerMaxWidth
}) => {
    return (
        <LimitedWidthContainer maxWidth={containerMaxWidth}>
            {top && (
                <View
                    horizontal
                    css={(th: Theme) => [
                        horizontalPaddedContent()(th),
                        css`
                            justify-content: flex-start;
                            position: relative;
                        `
                    ]}
                >
                    {top()}
                </View>
            )}
            <View
                css={(th: Theme) => [
                    css`
                        background: ${th.colors.white};
                    `,
                    paddedContent()(th)
                ]}
                className={className}
            >
                {children}
            </View>
        </LimitedWidthContainer>
    )
}
